import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis, Tooltip,
  AggregationInterval, ArgumentAxis, Aggregation,
  TickInterval, CommonSeriesSettings, } from 'devextreme-react/chart';
import PieChart, {
  Legend as PCLegend,
  Series as PCSeries,
  Tooltip as PCTooltip,
  Label,
} from 'devextreme-react/pie-chart';
import { groupBy } from '../../utils/miscUtil';
import { TagBox } from 'devextreme-react/tag-box';

const palette = ["rgba(20, 77, 109, 1)", "rgba(236, 80, 32, 1)", "rgba(92, 194, 215, 1)", "rgba(0, 162, 200, 1)", "rgba(20, 77, 109, 0.4)", "rgba(236, 80, 32, 0.4)", "rgba(92, 194, 215, 0.4)", "rgba(0, 162, 200, 0.4)"]

export default function ESGReportingStrategy(props) {
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [selectedCompaniesList, setSelectedCompaniesList] = useState([]);
  const [verificationData, setVerificationData] = useState([]);
  const [auditData, setAuditData] = useState([]);
  const [availableData, setAvailableData] = useState([]);
  const [reportingData, setReportingData] = useState([]);
  const [publicationData, setPublicationData] = useState([]);


  useEffect(() => {
    var fd = [];
    var fd1 = [];
    var i = 0;

    fd1 = groupBy(props.data, 'company_name')
    setAllCompaniesList(Object.keys(fd1).sort())

    var originalData = props.data
    if (selectedCompaniesList.length) {
      originalData = originalData.filter((it) => selectedCompaniesList.includes(it['company_name']));
    }

    fd = originalData.filter((e) => {return e["Identifier"]==="204" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setVerificationData(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="205" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"]});
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setAuditData(fd);

    fd = originalData.filter((e) => {return parseInt(e["Identifier"]) > 0 && parseInt(e["Identifier"]) < 34 && e["year"] ===(parseInt(props.year)-1).toString()});
    fd = groupBy(fd,"company_name");
    fd = Object.keys(fd).map((key) => {
      let fdd = fd[key].filter((e) => {return e["value"] && e["value"] !== "NR"})
      if (!fdd.length) {
        return {name: key, value: "No Metrics Reported"}
      }
      if (fdd.length === fd[key].length) {
        return {name: key, value: "All Metrics Reported"}
      }
      return {name: key, value: "Some Metrics Reported"}
    });
    
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['name'])}));
    setAvailableData(fd);

    fd = originalData.filter((e) => {return ["168", "169", "170", "171", "173"].includes(e["Identifier"]) && e["year"] ===(parseInt(props.year)-1).toString() && e["value"]});
    fd = groupBy(fd, "Metrics")
    fd1=[]
    for (i=0; i<Object.keys(fd).length; i++) {
      let it = {}
      let k = Object.keys(fd)[i]
      it["Metric"] = k
      let ffd = groupBy(fd[k],"value")
      Object.keys(ffd).map((key) => {
        it[key]=ffd[key].length
        it[key+"_companies"]=ffd[key].map((it) => it['company_name'])
      })
      fd1.push(it);
    }
    setReportingData(fd1);

    fd = originalData.filter((e) => {return e["Identifier"]==="206" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"]});
    fd.map((it) => {
      let m = (new Date(it.value)).getMonth()
      it.value = new Date(props.year, m, 1)
    })
    setPublicationData(fd);

  }, [props.data, props.year, selectedCompaniesList]);

  const onCompaniesChanged = useCallback((e) => {
    setSelectedCompaniesList(e.value);
  }, [setSelectedCompaniesList])

  const customizeTooltip = useCallback((pointInfo) => {
      var txt = ''
      txt = `<div><div class="tooltip-header">${pointInfo.argumentText}: ${pointInfo.valueText}</div><div class="tooltip-body">${pointInfo.point.data.companies.join(", ")}</div></div>`
      return {
        html: txt,
      }
    }, []);

  const customizeTooltip2 = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.argumentText}<br/>${pointInfo.seriesName} : ${pointInfo.valueText}</div><div class="tooltip-body">${pointInfo.point.data[pointInfo.seriesName+"_companies"].join(", ")}</div></div>`
    return {
      html: txt,
    }
  }, []);

  const customizeTooltip3 = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.argument.toLocaleString('default', { month: 'long' })}: ${pointInfo.value}</div><div class="tooltip-body">${pointInfo.point.aggregationInfo.data.map((it) => it['company_name']).join(", ")}</div></div>`
    return {
      html: txt,
    }
  }, []);

  const calculateCount = useCallback((aggregationInfo) => {
    if (!aggregationInfo.data.length) {
      return null;
    }
    return {
      value: aggregationInfo.intervalStart,
      cnt: aggregationInfo.data.length,
    };
  }, []);

  function customizePoint(point) {
    let fillId;
    switch (point.argument) {
      case 'Y':
        fillId = "rgba(20, 77, 109, 1)";
        break;
      case 'N':
        fillId = "rgba(236, 80, 32, 1)";
        break;
      case 'NR':
        fillId = "rgba(0, 0, 0, 0.3)";
        break;
      default:
        break;
    }
    return { color: { fillId } };
  }

  function customizePoint2(point) {
    let fillId;
    switch (point.argument) {
      case 'All Metrics Reported':
        fillId = "rgba(20, 77, 109, 1)";
        break;
      case 'Some Metrics Reported':
        fillId = "rgba(236, 80, 32, 1)";
        break;
      case 'No Metrics Reported':
        fillId = "rgba(0, 0, 0, 0.3)";
        break;
      default:
        break;
    }
    return { color: { fillId } };
  }


  return (
    <>
    <h4>Reporting Strategies in {parseInt(props.year)-1} </h4>
    <div className="d-flex flex-row">
      <TagBox
          dataSource={allCompaniesList}
          value={selectedCompaniesList}
          showDropDownButton={true}
          width="100%"
          activeStateEnabled={true}
          multiline={false}
          showSelectionControls={true}
          onValueChanged={onCompaniesChanged}
          label={"Company"}
          labelMode="floating"
          placeholder={"Select Companies"}
      />
    </div>
    <hr className={'mb-4'}/>

    <div className="d-flex flex-column justify-content-between">
      <h5>Companies Self-Reporting Framework Alignement</h5>
      <Chart
        id="chart"
        dataSource={reportingData}
        rotated={true}
      >
        <CommonSeriesSettings
          argumentField="Metric"
        >
          <Label
            wordWrap="normal"
            position="inside"
          />
        </CommonSeriesSettings>
        <ArgumentAxis>
          <Label
            wordWrap="normal"
            position="inside"
          />
        </ArgumentAxis>
        <Series
          type="stackedbar"
          valueField="Aligned"
          name="Aligned"
          color="rgba(20, 77, 109, 0.8)"
        />
        <Series
          type="stackedbar"
          valueField="Aspired"
          name="Aspired"
          color="rgba(236, 80, 32, 0.8)"
        />
        <Series
          type="stackedbar"
          valueField="Mentioned"
          name="Mentioned"
          color="rgba(0, 0, 0, 0.3)"
        />
        <ValueAxis showZero={true} />

        <Legend
          visible={true}
          rowCount={1}
          verticalAlignment="bottom"
          horizontalAlignment="center"/>
        <Tooltip
          enabled={true}
          customizeTooltip={customizeTooltip2}
        />
      </Chart>
      <hr className={'mb-4'}/>
      <h5>Report Publication Date</h5>
      <Chart
        id="chart"
        dataSource={publicationData}
      >
        <ArgumentAxis aggregatedPointsPosition="crossTicks">
          <AggregationInterval months={1} />
          <TickInterval months={1} />
        </ArgumentAxis>
        <CommonSeriesSettings
          argumentField="value"
        >
          <Aggregation
            enabled={true}
            calculate={calculateCount}
            method="custom"
          />
        </CommonSeriesSettings>
        <Series
          type="stackedbar"
          valueField="cnt"
          name="Value"
          color="rgba(20, 77, 109, 0.8)"
        />
        <ValueAxis showZero={true} />
        <Legend
          visible={false}
          rowCount={1}
          verticalAlignment="bottom"
          horizontalAlignment="center"/>
        <Tooltip
          enabled={true}
          customizeTooltip={customizeTooltip3}
        />
      </Chart>
      <hr className={'mb-4'}/>
      <h5>Third-Party Verification</h5>
      <div className="d-flex flex-row w-100">
        <div className="d-flex flex-column justify-content-between" style={{width:"50%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Third-party Audit/Assurance (any part of ESG Report)"}
            customizePoint={customizePoint}
            dataSource={verificationData}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1} horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"50%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Level of Audit or Assurance"}
            palette={palette}
            dataSource={auditData}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1} horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
      </div>
      <hr className={'mb-4'}/>
      <h5>AXPC Data Available</h5>
      <div className="d-flex flex-row w-100 justify-content-center">
        <PieChart
          id="pie"
          type="doughnut"
          customizePoint={customizePoint2}
          dataSource={availableData}
          resolveLabelOverlapping={"shift"}
        >
          <PCSeries argumentField="name">
            <Label visible={true} position="inside" backgroundColor="transparent"/>
          </PCSeries>
          <PCLegend rowCount={1} horizontalAlignment="center" verticalAlignment="bottom" />
          <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
          </PCTooltip>
        </PieChart>
      </div>
    </div>
    </>
  );
}
